import { Logo } from '../../../shared/ui/brand';
import { Avatar } from '../../../shared/ui/avatar';
import { PlusIcon } from '../../../shared/ui/icons';
import {
  Menu,
  MenuContent,
  MenuItem,
  MenuLabel,
  MenuSeparator,
  MenuTrigger,
} from '../../../shared/ui/menu';
import { ShortcutTooltip } from '../../../shared/ui/tooltip';
import { RAIL_ITEM, SHELL_CHORDS } from './nav';

export interface IOrganization {
  id: string;
  name: string;
  role?: 'owner' | 'admin' | 'member';
}

interface IOrgSwitcherProps {
  current: IOrganization;
  organizations: readonly IOrganization[];
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSwitch: (id: string) => void;
  onCreate: () => void;
  collapsed: boolean;
}

// Board 27: the logo is the organization menu; the name beside it only when expanded.
export const OrgSwitcher = ({
  current,
  organizations,
  open,
  onOpenChange,
  onSwitch,
  onCreate,
  collapsed,
}: IOrgSwitcherProps) => (
  <Menu open={open} onOpenChange={onOpenChange}>
    <ShortcutTooltip off={!collapsed} label={current.name} keys={SHELL_CHORDS.organizations.keys}>
      <MenuTrigger aria-label={`Switch organization, now ${current.name}`} className={RAIL_ITEM}>
        <span className="flex shrink-0 text-primary">
          <Logo size={20} />
        </span>
        {!collapsed && <span className="truncate font-medium text-primary">{current.name}</span>}
      </MenuTrigger>
    </ShortcutTooltip>

    <MenuContent side="right" align="start" className="w-rail-menu">
      <MenuLabel>Organizations</MenuLabel>
      {organizations.map((organization) => (
        <MenuItem
          key={organization.id}
          selected={organization.id === current.id}
          className={organization.id === current.id ? 'bg-hover-raised' : undefined}
          onSelect={() => {
            if (organization.id !== current.id) onSwitch(organization.id);
          }}
        >
          <Avatar name={organization.name} className="size-rail-mark text-caps" />
          <span className="min-w-0 truncate text-data">{organization.name}</span>
          {organization.role && (
            <span className="ml-auto font-mono text-micro text-muted">{organization.role}</span>
          )}
        </MenuItem>
      ))}

      <MenuSeparator />

      <MenuItem onSelect={onCreate}>
        <PlusIcon />
        <span className="text-data">New organization</span>
      </MenuItem>
    </MenuContent>
  </Menu>
);
